<template>
  <Popup v-model="popupShow" class="auth-info">
    <div class="auth-info-content">
      <div class="auth-info-title">信息提交后不支持修改，确认信息无误</div>
      <div class="auth-info-tips" style="color:#fff;">
         -
      </div>
      <div class="auth-info-core" style="line-height:25px; ">
        <div class="auth-info-core-name">
          <span class="e1">姓名</span>
          <span class="e2">{{ form.username }}</span>
        </div>
        <div class="auth-info-core-idcard">
          <span class="e1">身份证号</span>
          <span class="e2">{{ form.idcard }}</span>
        </div>
      </div>
      <div>
        <Button
          type="default"
          size="small"
          class="auth-info-btn"
          @click="cancelHandle"
          >信息有误</Button
        >
        <Button
          type="primary"
          size="small"
          class="auth-info-btn"
          :loading="confirmBtnLoading"
          :disabled="!confirmBtnStatus"
          :loading-text="confirmBtnText"
          @click="confirmHandle"
          >我已确认</Button
        >
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup, Button, Toast } from "vant";
import { bindIdcardNumApi } from "@/api/user";

export default {
  name: "AuthInfo",
  components: { Popup, Button },
  data() {
    return {
      popupShow: false,
      form: {},
      confirmBtnLoading: false,
      confirmBtnStatus: true,
      confirmBtnText: "处理中",
    };
  },
  methods: {
    show() {
      this.popupShow = true;
    },
    close() {
      this.popupShow = false;
    },
    setForm(form) {
      console.log(form);
      this.form = form;
    },
    cancelHandle() {
      this.$emit("cancel");
    },
    confirmHandle() {
      this.confirmBtnLoading = true;
      this.confirmBtnStatus = false;
    //   bindIdcardNumApi(this.form.phone)
    //     .then(({ status, data }) => {
    //       if (status === 200) {
    //         Toast({
    //           message: "验证码已发送",
    //           icon: "envelop-o",
    //         });
    //         this.$emit("ok", this.form);
    //         return;
    //       }
    //       Toast.fail(data || "系统繁忙,请稍后重试");
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //       Toast.fail("系统繁忙,请稍后重试");
    //     })
    //     .finally(() => {
    //       this.confirmBtnLoading = false;
    //       this.confirmBtnStatus = true;
    //     });
      this.$emit("ok", this.form);
    },
  },
};
</script>

<style>
.auth-info {
  width: 80%;
  min-height: 200px;
}
.auth-info-title {
  padding: 9px 0px 6px 6px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #eee;
}
.auth-info-tips {
  font-size: 14px;
  margin: 6px 12px;
  text-align: left;
  color: #4c4c4c;
}
.auth-info-core {
  text-align: left;
  width: 85%;
  margin: auto;
  margin-bottom: 8px;
  font-size: 15px;
}
.auth-info-core .e1 {
  width: 80px;
  display: inline-block;
}
.auth-info-core .e2 {
  color: red;
}
.auth-info-btn {
  margin: 8px 15px;
}
</style>